import Box from "@mui/material/Box";
import Skeleton from "@mui/material/Skeleton";

import AddRecipient from "./AddRecipient";
import List from "./List";

import BackdropLoader from "../../../components/BackdropLoader";

import { useGetBlacklistQuery } from "../recipientsApiSlice";

const Blacklist = () => {
	const {
		data: recipients,
		error,
		isLoading,
		isFetching,
	} = useGetBlacklistQuery();

	if (isLoading) {
		return (
			<Box
				sx={{
					display: "flex",
					flexDirection: "column",
					gap: "12px",
					mt: "12px",
				}}
			>
				<Skeleton variant="rectangular" height={40} />
				<Skeleton variant="rectangular" height={800} />
			</Box>
		);
	}

	return (
		<>
			<Box sx={{ position: "relative" }}>
				<Box
					sx={{
						position: "absolute",
						top: "13px",
						left: 0,
						zIndex: 120,
					}}
				>
					<AddRecipient />
				</Box>
				<List data={recipients} />
			</Box>
			<BackdropLoader isOpen={isFetching} />
		</>
	);
};

export default Blacklist;
